import React from "react";
import { History } from "history";

import {
    Alerta,
    TipoAlerta,
    Form,
    CampoTexto,
    Botao,
    TipoBotao,
} from "@intechprev/componentes-web";
import { Link } from "react-router-dom";

import { PageClean } from "..";
import { UsuarioService } from "../../services";
import { LoginEntidade } from "../../entidades";

interface Props {
    history?: History;
}

interface State {
    user: LoginEntidade;
    loading: boolean;
    mensagem: string;
    erro: string;
}

export default class EsqueciSenha extends React.Component<Props, State> {
    private alert = React.createRef<Alerta>();
    private form = React.createRef<Form>();

    constructor(props: Props) {
        super(props);

        this.state = {
            user: new LoginEntidade(),
            loading: false,
            mensagem: "",
            erro: "",
        };
    }

    enviarSenha = async () => {
        try {
            var alert = this.alert.current;
            var form = this.form.current;

            await alert.limparErros();
            await form.validar();

            if (this.state.user.Cpf.length < 11) {
                await this.alert.current.adicionarErro('Campo "CPF" inválido.');
                return;
            }

            if (form.isValido()) {
                var resultado = await UsuarioService.CriarAcesso(
                    this.state.user
                );
                window.alert(resultado);
                this.props.history.push("/");
            }
        } catch (err) {
            if (err.response)
                this.alert.current.adicionarErro(err.response.data);
            else this.alert.current.adicionarErro(err);
        }
    };

    render() {
        return (
            <PageClean {...this.props}>
                <h4>Bem vindo ao portal da EQTPREV</h4>

                <h5>
                    <b>Esqueci minha senha / Primeiro Acesso</b>
                    <br />
                    <br />
                    <small>
                        Preencha as informações para que possamos gerar uma
                        senha que será enviada para seu email cadastrado na
                        fundação EQTPREV.
                    </small>
                </h5>

                <Form ref={this.form}>
                    <CampoTexto
                        contexto={this}
                        parent={"user"}
                        nome={"Cpf"}
                        tipo={"number"}
                        max={11}
                        valor={this.state.user.Cpf}
                        placeholder="CPF (somente números)"
                    />

                    <CampoTexto
                        contexto={this}
                        parent={"user"}
                        nome={"DataNascimento"}
                        valor={this.state.user.DataNascimento}
                        placeholder={"Data de Nascimento"}
                        mascara={"99/99/9999"}
                    />

                    <CampoTexto
                        contexto={this}
                        parent={"user"}
                        nome={"Email"}
                        valor={this.state.user.Email}
                        placeholder={"E-mail"}
                    />

                    <Botao
                        titulo={"Enviar Nova Senha"}
                        tipo={TipoBotao.primary}
                        block
                        submit
                        usaLoading
                        onClick={this.enviarSenha}
                    />
                    <Link className="btn btn-light btn-block" to="/login">
                        Voltar para a página de Login
                    </Link>
                    <br />
                    <Alerta
                        ref={this.alert}
                        padraoFormulario
                        tipo={TipoAlerta.danger}
                        tamanho={"12"}
                    />
                </Form>
            </PageClean>
        );
    }
}
